<script setup lang="ts">
import {Project, User} from "@/types";
import {ref} from "vue";
import {router} from "@inertiajs/vue3";

interface Props {
  project: Project,
  group: any,
  user: User
}
const props = defineProps<Props>()
const emits = defineEmits(['confirm'])

const isDialogOpen = ref(false)
const confirmAction = ref(false)
const loading = ref(false)

const remove = () => {
    router.patch(route('projects.users.update', {project: props.project.slug, user: props.user.name}), {
        group_id: null
    }, {
        onStart: () => {
            loading.value = true;
        },
        onFinish: () => {
            loading.value = false;
        },
        onSuccess: () => {
            isDialogOpen.value = false
            emits('confirm')
        }
    })
}
</script>

<template>
    <v-dialog
        v-model="isDialogOpen"
        max-width="500"
        overlay-opacity="0.1"
    >
        <template #activator="{ props: attrs }">
            <v-btn
                variant="text"
                small
                color="error"
                class="text-none text-caption text-body-2"
                v-bind="attrs"
            >
                Remove
            </v-btn>
        </template>

        <v-card
            :flat="true"
            rounded="lg"
            class="border"
        >
            <v-card-title class="font-weight-bold border-bottom text-body-2 bg-grey-lighten-4 border-b">
                Confirm you want to remove this collaborator
                <v-btn
                    variant="plain"
                    size="x-small"
                    icon="mdi-close"
                    class="float-end"
                    @click="isDialogOpen = false"
                />
            </v-card-title>

            <v-card-text class="pt-5 black--text">
                <p class="mb-0 text-body-2">
                    Once removed, <b>{{ user.name }}</b> will no longer be a member of <b>{{ group.name }}</b> group. However, they will still have access to the project.
                </p>
            </v-card-text>

            <v-card-actions class="px-5">
                <v-btn
                    variant="text"
                    size="small"
                    class="text-error text-none font-weight-medium text-body-2 bg-grey-lighten-4 border py-4 mb-2"
                    :block="true"
                    rounded="lg"
                    :loading="loading"
                    @click="remove"
                >
                    Remove {{ user.name }} from this group
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<style scoped>

</style>
